import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Work Order ID',
    field: 'workOrderID',
    filter: 'text',
    hide: true,
  },
  {
    title: 'Work Order #',
    field: 'workOrderNumber',
    filter: 'text',
    width: '150',
    searchable: true,
    navigate: true,
  },
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    width:'150'
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
    width:'150'
  },
  {
    title: 'Builder Job Number',
    field: 'jobNumber',
    filter: 'text',
    searchable: true,
    width:'200'
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  {
    title: 'Service Code',
    field: 'serviceCode',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  // {
  //   title: 'Forecasted Date',
  //   field: 'forecastedDate',
  //   filter: 'text',
  //   searchable: true,
  //   editor: 'text',
  //   width: '150',
  // },

  // {
  //   title: 'Requested On',
  //   field: 'inspectionRequestOn',
  //   filter: 'text',
  //   searchable: true,
  //   width: '130',
  // },
  {
    title: 'Cut off time',
    field: 'cutOffTime',
    filter: 'text',
    searchable: true,
    width: '120',
  },
  {
    title: 'Inspector',
    field: 'inspectorName',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '150',
  },
  {
    title: 'Scheduled Date',
    field: 'scheduledDate',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '200',
  },
  {
    title: 'Time',
    field: 'scheduledTime',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '100',
  },
  {
    title: 'AM/PM',
    field: 'scheduledMeridiem',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '100',
  },
  // {
  //   title: 'Cut off time',
  //   field: 'cutOffTime',
  //   filter: 'text',
  //   searchable: true,
  //   width: '120',
  // },
  {
    title: 'Worked Hours',
    field: 'workedHours',
    filter: 'text',
    searchable: true,
    width: '140',
  },
  {
    title: 'Status',
    field: 'workOrderStatus',
    filter: 'text',
    searchable: true,
    width: '150',
  },
];
